<div class="dialog-viewer">
    <h2 mat-dialog-title>Edit Simulator</h2>

    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-dialog-content>
            <div class="row">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            </div>
            <div class="container-fluid">
                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Bay Name</mat-label>
                            <input matInput formControlName="bayName" required>
                            <mat-error *ngIf="form.get('bayName').errors?.required">
                                Bay Name is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Bay Number</mat-label>
                            <input matInput type="number" formControlName="bayNumber" required>
                            <mat-error *ngIf="form.get('bayNumber').errors?.required">
                                Bay Number is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Capacity</mat-label>
                            <input matInput type="number" formControlName="capacity" required>
                            <mat-error *ngIf="form.get('capacity').errors?.required">
                                Capacity is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12">
                        <mat-checkbox formControlName="isAvailable">Available</mat-checkbox>
                    </div>
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions>
            <button mat-raised-button type="submit" 
                    [disabled]="!form.valid || isLoading">Save</button>
            <button mat-raised-button type="button" color="warn" 
                    [disabled]="isLoading" 
                    (click)="dialogRef.close('cancel')">Cancel</button>
        </mat-dialog-actions>
    </form>
</div>
